import React from "react";
import { Dialog } from "components/Dialog";

export interface ConfirmationDialogProps {
  /** Whether the dialog is open */
  open: boolean;
  /** The title to display in the header of the dialog */
  title: string;
  /** Whether the dialog is waiting on something to load, the actions will be disabled during this time. */
  loading?: boolean;
  /** Whether an error has occurred, an error message will be shown in the bottom of the dialog.
   *  This can be customised using the errorMessage property.*/
  error?: boolean;
  /** The error message to display when the error property is true */
  errorMessage?: string;
  /** The text to display in the confirmation button */
  confirmText?: string;
  /** The callback fired when the cancel button is clicked */
  onCancel?: () => void;
  /** The callback fired when the user clicks the close button or clicks outside the dialog */
  onClose: () => void;
  /** The callback fired when the user clicks the confirm button */
  onConfirm: () => void;
}

/**
 * A simple confirmation dialog
 */
export const ConfirmationDialog = ({
  open,
  title,
  children,
  loading = false,
  error = false,
  errorMessage = "An error occurred while performing your request, please try again later.",
  confirmText = "Confirm",
  onCancel,
  onClose,
  onConfirm
}: React.PropsWithChildren<ConfirmationDialogProps>): JSX.Element => {
  return (
    <Dialog
      dialogId="dialog-confirmation"
      size="small"
      title={title}
      open={open}
      errorText={error ? errorMessage : undefined}
      confirmText={confirmText}
      onConfirm={onConfirm}
      onCancel={onCancel}
      onClose={onClose}
      actionsDisabled={loading}
      allowClickaway
    >
      {children}
    </Dialog>
  );
};
